import React from 'react';
import DashLayout from '../components/PlumPlusDash/DashLayout';

export default function OrientationRessources() {
  return (
    <DashLayout>
      <h1>Ressources d'Orientation</h1>
      {/* ...content... */}
    </DashLayout>
  );
}
